import { FC } from 'react';

import { CustomerCallCenterBox } from '@service/giftStore/page/CustomerCallCenterBox';

export const GiftDepositInfoBox: FC = function GiftDepositInfoBox() {
  return (
    <div className="p-4 py-4 theme-bg-1">
      <CustomerCallCenterBox />
    </div>
  );
};
